import { useRef, useEffect, useCallback } from 'react';

const useWasRendered = () => {
  const wasRendered = useRef(false);
  useEffect(() => {
    return () => (wasRendered.current = false);
  }, []);

  const setWasRendered = useCallback(() => {
    wasRendered.current = true;
  }, []);

  return { wasRendered, setWasRendered };
};

export default useWasRendered;
